// import { Link } from "react-router-dom"

// const Register = () => {
//     return (
//         <>
//         <div className="tf-page-title style-2">
//             <div className="container-full">
//                 <div className="heading text-center">Register</div>
//             </div>
//         </div>
//         <section className="flat-spacing-10">
//             <div className="container">
//                 <div className="form-register-wrap">
//                     <div className="flat-title align-items-start gap-0 mb_30 px-0">
//                         <h5 className="mb_18">Register</h5>
//                         <p className="text_black-2">Sign up for early Sale access plus tailored new arrivals, trends and promotions. To opt out, click unsubscribe in our emails</p>
//                     </div>
//                     <div>
//                         <form className="" id="register-form" action="#" method="post" accept-charset="utf-8" data-mailchimp="true">
//                             <div className="tf-field style-1 mb_15">
//                                 <input className="tf-field-input tf-input" placeholder=" " type="text" id="property1" name="first name"/>
//                                 <label className="tf-field-label fw-4 text_black-2" for="property1">First name</label>
//                             </div>
//                             <div className="tf-field style-1 mb_15">
//                                 <input className="tf-field-input tf-input" placeholder=" " type="text" id="property2" name="last name"/>
//                                 <label className="tf-field-label fw-4 text_black-2" for="property2">Last name</label>
//                             </div>
//                             <div className="tf-field style-1 mb_15">
//                                 <input className="tf-field-input tf-input" placeholder=" " type="email" id="property3" name="email"/>
//                                 <label className="tf-field-label fw-4 text_black-2" for="property3">Email *</label>
//                             </div>
//                             <div className="tf-field style-1 mb_30">
//                                 <input className="tf-field-input tf-input" placeholder=" " type="password" id="property4" name="password"/>
//                                 <label className="tf-field-label fw-4 text_black-2" for="property4">Password *</label>
//                             </div>
//                             <div className="mb_20">
//                                 <Link type="submit" to="/admindashboard" className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Register</Link>
//                             </div>
//                             <div className="text-center">
//                                 <Link to="/login" className="tf-btn btn-line">Already have an account? Log in here<i className="icon icon-arrow1-top-left"></i></Link>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </section>
//         </>
//     )
// }
// export default Register


import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const Register = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mob_number, setMobnumber] = useState("");

  const navigate = useNavigate(); // Initialize useNavigate

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("/api/register", {
        firstname,
        lastname,
        mob_number,
        email,
        password,
      });
      alert(response.data.message);
      if (response.status === 201) {
        navigate("/login"); // Redirect to the login page
      }
    } catch (error) {
      alert("Error: " + error.response?.data?.message || "An error occurred.");
    }
  };

  return (
    <>
      <div className="tf-page-title style-2">
        <div className="container-full">
          <div className="heading text-center">Register</div>
        </div>
      </div>
      <section className="flat-spacing-10">
        <div className="container">
          <div className="form-register-wrap">
            <div className="flat-title align-items-start gap-0 mb_30 px-0">
              <a href="/adminhome">
                <h5 className="mb_18">Register</h5>
              </a>
              <p className="text_black-2">
                Sign up for early Sale access plus tailored new arrivals, trends
                and promotions. To opt out, click unsubscribe in our emails.
              </p>
            </div>
            <div>
              <form
                id="register-form"
                method="post"
                onSubmit={handleSubmit}
              >
                <div className="tf-field style-1 mb_15">
                  <input
                    className="tf-field-input tf-input"
                    placeholder=" "
                    type="text"
                    id="property1"
                    name="first_name"
                    onChange={(e) => setFirstname(e.target.value)}
                    required
                  />
                  <label className="tf-field-label fw-4 text_black-2" htmlFor="property1">
                    First name
                  </label>
                </div>
                <div className="tf-field style-1 mb_15">
                  <input
                    className="tf-field-input tf-input"
                    placeholder=" "
                    type="text"
                    id="property2"
                    name="last-name"
                    onChange={(e) => setLastname(e.target.value)}
                  />
                  <label className="tf-field-label fw-4 text_black-2" htmlFor="property2">
                    Last name
                  </label>
                </div>
                <div className="tf-field style-1 mb_15">
                  <input
                    className="tf-field-input tf-input"
                    placeholder=" "
                    type="number"
                    id="property3"
                    name="mob_number"
                    onChange={(e) => setMobnumber(e.target.value)}
                    required
                  />
                  <label className="tf-field-label fw-4 text_black-2" htmlFor="property3">
                    Mobile Number *
                  </label>
                </div>
                <div className="tf-field style-1 mb_15">
                  <input
                    className="tf-field-input tf-input"
                    placeholder=" "
                    type="email"
                    id="property4"
                    name="email"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label className="tf-field-label fw-4 text_black-2" htmlFor="property4">
                    Email *
                  </label>
                </div>
                <div className="tf-field style-1 mb_30">
                  <input
                    className="tf-field-input tf-input"
                    placeholder=" "
                    type="password"
                    id="property5"
                    name="password"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <label className="tf-field-label fw-4 text_black-2" htmlFor="property5">
                    Password *
                  </label>
                </div>
                <div className="mb_20">
                  <button
                    type="submit"
                    className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center"
                  >
                    Register
                  </button>
                </div>
                <div className="text-center">
                  <a href="/login" className="tf-btn btn-line">
                    Already have an account? Log in here
                    <i className="icon icon-arrow1-top-left"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;
